import React from 'react'
import { Button, Input } from 'antd';
import { ContainerModal } from './ContainerModal';
import { CustomModalPortal } from '../Custom/CustomModalPortal';
import { iconsDetailsProyectMenu } from '../../assets/icons/detailsProjectMenu';
import { DeleteFilled } from "@ant-design/icons";

export const ContainerDeleteProject = ({
    type = "",
    isOpen = false,
    name = "",
    disableButton = true,
    onInputChange = () => { },
    onCancel = () => { },
    onConfirm = () => { },
    loading = false,
}) => {

    return (
        <CustomModalPortal isVisible={isOpen}>
            <div className="bg-black bg-opacity-45 w-full h-full fixed top-0 left-0 flex justify-center items-center">
                <ContainerModal className="w-[500px] " title={type === "delete" ? "Eliminar Proyecto" : "Desvincular proyecto"} isNecesaryIcon={false}>
                    <div className=" pt-2">
                        <div className="h-[60px] w-full flex justify-center items-center">
                            {type === "delete" ? (
                                <DeleteFilled className="cursor-pointer text-red-700 text-[56px]" />
                            ) : (
                                <img className="w-[56px] h-[56px] object-contain" src={iconsDetailsProyectMenu.desvincularproyecto} alt="icon" />
                            )}
                        </div>
                        <div className="py-2 flex justify-center items-center">
                            <p className="text-[12px]">
                                Escribe el nombre del proyecto: <span className="font-bold">{name}</span>
                            </p>
                        </div>
                        <div className="">
                            <Input
                                placeholder="Nombre del proyecto"
                                onChange={onInputChange}
                            />
                        </div>
                        <div className="w-full h-[40px] mt-4 overflow-hidden flex justify-center gap-4">
                            <Button htmlType="button" onClick={onCancel}>
                                Cancelar
                            </Button>
                            <Button
                                onClick={onConfirm}
                                type="primary"
                                className={`${disableButton ? "bg-gray-300" : "bg-primaryTwo"}`}
                                disabled={disableButton}
                                loading={loading}
                            >
                                Aceptar
                            </Button>
                        </div>
                    </div>
                </ContainerModal>
            </div>
        </CustomModalPortal>
    )
}
